var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('textarea',{staticClass:"token",attrs:{"cols":"30","rows":"10"},domProps:{"value":_vm.token}})])}
var staticRenderFns = []

export { render, staticRenderFns }